export const questionnaireCountByStatusEndPoint = 'questionnaires/count/all';
export const questionnairesEndPoint = 'questionnaires';
